import { Component, type ErrorInfo, type ReactNode } from "react";
import { reportError } from "@/lib/errors";

/** Last line of defence: a crashed React tree shows a reload prompt instead of a blank page, and reports the error. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    reportError(error, `React component stack: ${info.componentStack ?? ""}`.slice(0, 2000));
  }
  render() {
    if (!this.state.failed) return this.props.children;
    const es = /^es/i.test(document.cookie.match(/mn_locale=(\w+)/)?.[1] ?? "es");
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 p-8 text-center">
        <div className="wordmark text-3xl">.MAYUSCULANOTE</div>
        <p className="max-w-md text-muted">
          {es
            ? "Algo salió mal en esta pantalla. Ya recibimos el reporte. Tu trabajo está guardado en el servidor."
            : "Something went wrong on this screen. We received the report. Your work is saved on the server."}
        </p>
        <button
          type="button"
          onClick={() => location.reload()}
          className="rounded-sm bg-text px-4 py-2 text-sm font-semibold text-bg"
        >
          {es ? "Recargar" : "Reload"}
        </button>
      </div>
    );
  }
}
